<template>
  <div id="pano" style="width:100%; height:100%;"></div>
</template>

<script>
import "@/assets/css/redefine.css";
import {mapGetters} from "vuex"

export default {
  data() {
    return {
      krpanoObj: false,
    };
  },
  computed: {
    ...mapGetters(['vrbase'])
  },
  methods: {
    launchKrpano() {
      launchKrpano(null,"/ssr/static/tour/tour.swf");
    },
  },
  created() {},
  mounted() {
  },
};
</script>

<style lang="less" scoped>
@-ms-viewport {
  width: device-width;
}

@media only screen and (min-device-width: 800px) {
  html {
    overflow: hidden;
  }
}

html {
  height: 100%;
}

body {
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  font-family: microsoft yahei, Helvetica, sans-serif;
  background-color: #000000;
}

.marquee {
  position: absolute;
  overflow: hidden;
  height: 34px;
  line-height: 34px;
  width: 100%;
  white-space: nowrap;
  z-index: 800;
  color: white;
  text-align: right;
  padding-right: 10px;
  letter-spacing: 1px;
  font-family: 黑體;
  font-size: 15px;
  background: rgba(0, 0, 0, 0.3);
}

.affiche_text {
  position: absolute;
  top: 0;
  left: 100%;
  line-height: 34px;
  display: block;
  word-break: keep-all;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#sand {
  position: absolute;
  width: 45%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

#redpack_view .modal-dialog {
  width: 330px;
  background-color: #e4312d;
  position: relative;
  padding: 50px 10px 30px 10px;
  margin: auto;
}

#redpack_view .card_img {
  position: absolute;
  left: 40px;
  top: -88px;
}

#redpack_view .card_close {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 6px;
  top: -13px;
  background-color: #e4312d;
  border-radius: 25px;
  padding-left: 6px;
  padding-top: 2px;
  cursor: pointer;
}

#redpack_view .card_close .icon-times {
  color: #fff;
  font-size: 18px;
}

#redpack_view .card_wrap {
  background-color: #fff;
  width: 100%;
  min-height: 320px;
  border-radius: 10px;
}

#redpack_view .card_title {
  height: 50px;
  background-color: #d5d5d5;
  width: 100%;
  border-radius: 10px;
  text-align: center;
  line-height: 50px;
  position: relative;
}

#redpack_view .card_title span {
  font-size: 18px;
  font-weight: bold;
  color: #434343;
}

#redpack_view .card_title div {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  position: absolute;
  background-color: #e4312d;
  bottom: -8px;
}

#redpack_view .card_title .left_shade {
  left: -7px;
}

#redpack_view .card_title .right_shade {
  right: -7px;
}

#redpack_view .card_content {
  margin-top: 20px;
  padding: 20px;
}

#redpack_view .card_content .line {
  height: 1px;
  width: 30%;
  border-bottom: 1px solid #e66565;
}

#redpack_view .card_content .card_sysm {
  width: 30%;
  height: 30px;
  border: 1px solid #e66565;
  margin-top: -15px;
  border-radius: 30px;
  text-align: center;
  line-height: 30px;
  margin-left: 5%;
}

#redpack_view .card_content .card_sysm span {
  color: #fa9488;
}

#redpack_view .card_content_text {
  margin-top: 25px;
}

#redpack_view .card_footer {
  height: 50px;
  border-top: 1px dotted;
  line-height: 45px;
  text-align: center;
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  #redpack_view .modal-dialog {
    width: 90%;
  }

  .card_content_text {
    max-height: 200px;
    overflow: auto;
  }
}
</style>